export default function getPathDepth(pathname: string) {
  const pathSegments = pathname.split('/').filter(Boolean);

  return pathSegments.length;
}
